module.exports = __webpack_public_path__ + "img/specif_eng.6381cc8c.jpg";